import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { GlobalService } from '@core/services';
import { ContactUsService } from '@core/services/contact.service';
import { switchMap } from 'rxjs';

@Component({
    selector: 'app-blog-details',
    templateUrl: './blog-details.component.html',
    styleUrls: ['./blog-details.component.scss'],
})

export class BlogDetailsComponent implements OnInit {
    title = "";
    date = "";
    summary = "";
    body = "";
    image_url = "";
    facebookLink = "";
    twitterLink = "";
    lang = '';
    constructor(
        private contactService: ContactUsService,
        private route: ActivatedRoute,
        private router: Router,
    ) { }

    ngOnInit(): void {

        this.lang = localStorage.getItem('language') || 'en';
        this.facebookLink = "https://www.facebook.com/RoboGardenInc/";
        this.twitterLink = "https://twitter.com/RoboGardenInc";
        this.getData();
    }

    getData() {
        const title = this.route.snapshot.paramMap.get('title');
        console.log(title);
        this.contactService.getSpecificBlog(title).subscribe(res => {
            if (res) {
                this.title = res.Object.title;
                this.summary = res.Object.summary;
                this.image_url = res.Object.image_url;
                this.date = res.Object.date;
                this.body = res.Object.body;
            }
        }, err => {
        });
    }
    goTo(title: any) {
        this.router.navigateByUrl(`/blog/${title}`).then(() => {
            window.location.reload();
        });
    }
}
